const employees = {
  employeesList: "قائمه الموظفين",
  viewEmployee: "عرض بيانات الموظف",
  editProfile: "تعديل الملف الشخصي",
  deleteEmployee: "حذف",
  deleteEmployeeTitle: "حذف الموظف",
  deleteEmployeeConfirm: "هل أنت متأكد أنك تريد حذف هذا الموظف؟",
  deleteModalNo: "لا",
  deleteModalYes: "نعم",
  editEmployeeTitle: "تعديل الموظف",
  showingRange: "عرض {from}-{to} من أصل {total} موظف",
  editEmployee: "تعديل",
  searchPlaceholder: "ابحث عن موظف",
  noDataDescription: "عذرا لاتوجد نتائج",
  profile: "الملف الشخصي",
  email: "البريد الالكتروني",
  mobileNumber: "رقم الهاتف",
  addProjectManager: {
    createEmployee: "أضف موظف",
    addEmployee: "اضافه موظف",
    name: "الاسم",
    email: "البريد الالكتروني",
    mobileNumber: "رقم الهاتف",
    jobTitle: "المسمى الوظيفي",
    labels: {
      name: "الاسم",
      email: "البريد الالكتروني",
      mobileNumber: "رقم الهاتف",
      jobTitle: "المسمى الوظيفي",
      employeeImage: "صورة الموظف",
      uploadLabel: "رفع صورة",
      projectManager: "مدير المشروع",
    },
    placeholders: {
      name: "ادخل الاسم",
      email: "ادخل البريد الالكتروني",
      mobileNumber: "ادخل رقم الهاتف",
      jobTitle: "ادخل المسمى الوظيفي",
      projectManager: "حدد مدير المشروع",
    },
  },
  listEmployees: {
    name: "الاسم",
    email: "البريد الالكتروني",
    mobile: "رقم الهاتف",
    jobTitle: "المسمى الوظيفي",
    actions: "الإجراءات",
  },
};
export default employees;
